/* GemShop 2026-09-15: swatch "Engraving" (Text on N sides) acompanha a cor escolhida.
   Le o JSON de variantes que o tema ja injeta dentro do picker e, a cada mudanca de opcao,
   troca a miniatura pela foto da variante (barra prata/dourada) e recalcula o extra de preco. */
(function () {
  if (window.__gsEng) return; window.__gsEng = 1;
  var PICKERS = 'variant-radios, variant-radios-detail, variant-group-detail, variant-radios-single, variant-radios-sticky, variant-group-sticky';

  function dinheiro(cents) {
    var g = window.themeGlobalVariables || {};
    var fmt = (g.settings && g.settings.money_format) || g.money_format || window.__gsMoneyFormat || '';
    var t = '';
    try { if (fmt && window.Shopify && typeof Shopify.formatMoney === 'function') t = Shopify.formatMoney(cents, fmt); } catch (e) { t = ''; }
    if (!t) return null; // theme.js ainda nao carregou: deixa o valor que o Liquid renderizou
    // o money_format com moeda vem com <span class=money> e o codigo ISO: fica so simbolo + valor
    return String(t).replace(/<[^>]*>/g, '').replace(/\s*[A-Z]{3}\s*$/, '').replace(/([.,])00(?!\d)/, '').trim();
  }

  function sincronizar(root) {
    var labels = root.querySelectorAll('label.gs-eng');
    if (!labels.length) return;
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return;
    var variants; try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;
    var pos = parseInt(labels[0].getAttribute('data-gs-eng-pos'), 10) || 2;
    var sel = {};
    var sets = root.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var r = sets[i].querySelector('input[type=radio]:checked');
      if (r) sel[i + 1] = r.value;
    }
    var iguais = variants.filter(function (v) {
      for (var k = 1; k <= 3; k++) {
        if (k === pos || sel[k] === undefined) continue;
        if (v['option' + k] !== sel[k]) return false;
      }
      return true;
    });
    if (!iguais.length) return;
    var min = Math.min.apply(null, iguais.map(function (v) { return v.price; }));
    labels.forEach(function (l) {
      var val = l.getAttribute('data-gs-eng');
      var v = iguais.filter(function (x) { return x['option' + pos] === val; })[0];
      if (!v) return;
      var img = l.querySelector('[data-gs-eng-img]');
      var src = v.featured_image && v.featured_image.src;
      if (img && src) {
        var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=156';
        if (img.getAttribute('src') !== u) img.src = u;
      }
      var d = l.querySelector('[data-gs-eng-delta]');
      if (d) {
        var fm = v.price > min ? dinheiro(v.price - min) : '';
        if (fm !== null) {
          // dentro de span.money para o Nova converter (o observador do tema pede a conversao ao inserir)
          var t = fm ? '+<span class="money">' + fm + '</span>' : '';
          if (d.getAttribute('data-gs-eng-fm') !== t) { d.setAttribute('data-gs-eng-fm', t); d.innerHTML = t; }
        }
      }
    });
  }

  function todos() { document.querySelectorAll(PICKERS).forEach(sincronizar); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest) return;
    var root = t.closest(PICKERS);
    if (root) setTimeout(function () { sincronizar(root); }, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
})();
